<template lang="pug">
  main
    Loader(v-show="isLoading")
    .container
      .columns.is-vcentered
        .column.is-2
          a.button.is-dark.is-rounded.is-small(@click="cerrarMarcas")
            i.fas.fa-times
            | &nbsp Cerrar
        .column.is-6
          .field
            label.label Nueva Marca
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Nombre de la nueva Marca.',
                v-model="nombre",
              )
          
        .column.is-3
          a.button.is-success(@click="saveMarca()") Guardar
</template>

<script>
import Loader from '../shared/Loader.vue'
import InventarioServices from '../../services/inventario/inventario'

export default {
  name: 'NewMarca',
  components: { Loader },
  data () {
    return {
      nombre: '',
      isLoading: false,
    }
  },
  methods: {
    cerrarMarcas () {
      this.$emit('closeMarca', false)
    },
    saveMarca () {
      this.isLoading = true
      let id = Date.now()
      console.log(id)
      console.log(this.nombre)
      InventarioServices.addMarca(id, this.nombre)
        .then(res => {
          console.log(res)
          if (res.success) {
            setTimeout(() => {
              this.isLoading = false
              this.nombre = ''
              this.cerrarMarcas()
            }, 250);
          } else {
            this.isLoading = false
            console.log(res.respuesta)
          }
        })
    }
  }

}
</script>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/NewMarca.vue